import { RootState } from "store";
import { createDraftSafeSelector } from "@reduxjs/toolkit";

export const getUserDevices = (state: RootState) => state.userInfo;

export const getUserRole = (state: RootState) => state.userInfo.role;

export const getUserName = (state: RootState) => state.userInfo.username;

export const getUserInfo = (state: RootState) => state.userInfo;

export const getUserId = createDraftSafeSelector(
	getUserInfo,
	(state) => state.id
);

export const getTrialDaysRemaining = (state: RootState) =>
	state.userInfo.days_remaining_for_trial;

export const getIsPayed = (state: RootState) => state.userInfo.is_payed;

export const getTrialInfo = createDraftSafeSelector(
	getUserInfo,
	(state) => ({
		daysRemaining: state.days_remaining_for_trial,
		isPayed: state.is_payed,
	})
);
